import { Link, NavLink } from 'react-router-dom';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="nav-left">
        <Link to="/" className="nav-name">Xiaoyi (Mimi) Chen</Link>
        <span className="nav-divider">|</span>
        <div className="nav-icons">
          <a href="https://github.com/mimixiaoyichen" target="_blank" rel="noreferrer">
            <FaGithub size={27} />
          </a>
          <a href="https://www.linkedin.com/in/xiaoyi-mimi-chen/" target="_blank" rel="noreferrer">
            <FaLinkedin size={27} />
          </a>
          <a
            href="/docs/MimiChen_Resume.pdf"
            className="cv-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            [cv]
          </a>
        </div>
      </div>

      <div className="nav-right">
        <NavLink to="/" end>About</NavLink>
        <NavLink to="/projects">Projects</NavLink>
        <NavLink to="/contact">Contact</NavLink>
      </div>
    </nav>
  );
}
